import { Box } from "@mui/material";
import { UseFormReturn} from "react-hook-form";

import { getCountriesAndStatesOptions } from "@/utils/forms/getCountriesAndStatesOptions";
import { useGetCountriesAndStatesQuery } from "@/redux-store/api/marketingApi";

import Field from "@/components/RHFcomponents/Field";
import DropdownInput from "@/components/RHFcomponents/DropdownInput";
import PhoneInput from "@/components/RHFcomponents/PhoneInput";

interface IProps {
  methods: UseFormReturn<ICheckoutForm, unknown, undefined>;
}

const FormFirstStep: React.FC<IProps> = ({ methods: { control, watch } }) => {
  const { data } = useGetCountriesAndStatesQuery({});
  const { countryOptions, stateOptions } = getCountriesAndStatesOptions(data);
  const isUSAselected = watch().idCountry === 1;
  const gap = { xs: 2, md: 3 }; // Styles

    return (
    <Box display="flex" gap={gap} flexDirection="column">
      <Box display="flex" justifyContent="space-between" gap={gap}>
        <Field
          name="firstName"
          control={control}
          placeholder="Your first name"
        />
        <Field name="lastName" control={control} placeholder="Your last name" />
      </Box>
      <Field name="companyName" control={control} placeholder="Company name" />
      <Field name="email" control={control} placeholder="Email" />

      <Field
        name="streetAddress"
        control={control}
        placeholder="Your street name and number"
      />

      <Box display="flex" justifyContent="space-between" gap={gap}>
        <Field name="city" control={control} placeholder="Your city / town" />
        <Field name="zipCode" control={control} placeholder="Your ZIP code" />
      </Box>

      <Box
        display="flex"
        justifyContent="space-between"
        gap={gap}
        sx={{
          "& .MuiFormControl-root:last-of-type": {
            display: isUSAselected ? "block" : "none",
          },
        }}
      >
        {countryOptions.length > 0 && (
          <DropdownInput
            name="idCountry"
            control={control}
            options={countryOptions}
            placeholder="Your country"
          />
        )}
        {stateOptions.length > 0 && (
          <DropdownInput
            name="idState"
            placeholder="Your State"
            control={control}
            options={stateOptions}
          />
        )}
      </Box>

      <PhoneInput
        name="phoneNumber"
        control={control}
        placeholder="Your phone"
      />
    </Box>
  );
};

export default FormFirstStep;
